import React from "react";
import { TermsOfServicePage } from "../../components/TermsOfService/TermsOfService";

const TermsOfService: React.FC = () => <TermsOfServicePage />;

export default TermsOfService;
